module.exports = __webpack_public_path__ + "static/media/founder.48db6b68.jpg";